import React from 'react';

import { StatesDropdown } from '../states-dropdown';

export function StatesDropdownContainer({
	parentType,
	removeServicesAvailability,
	statesDropdown,
}) {
	const { _id, _key } = statesDropdown || {};

	return (
		<div
			className='states-container'
			key={_key || _id}
			data-type={'textContent'}
		>
			<StatesDropdown
				parentType={parentType}
				showAvailableStatesOnly={
					statesDropdown?.statesVisibility === 'availableStates'
				}
				statesVisibility={statesDropdown?.statesVisibility}
				servicesVisibility={
					!removeServicesAvailability &&
					statesDropdown?.servicesVisibility
				}
			/>
		</div>
	);
}
